<template>
    <button
        type="button"
        @click.prevent="$emit('toggleFavorite')"
        class="h-full w-full justify-center items-center flex active:outline-none active:ring-0 focus:ring-0 focus:outline-none"
        :class="buttonClass"
        tabindex="0"
    >
        <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            :class="svgClass"
        >
            <path
                d="M9.99902 5.22362C15.134 0.015136 23.9367 9.68805 9.99906 17.5C-3.93867 9.68808 4.86405 0.0151348 9.99902 5.22362Z"
                stroke-width="1.66667"
                stroke-linejoin="round"
            />
        </svg>
    </button>
</template>

<script setup>
import { computed } from 'vue';
const props = defineProps({
    buttonClass: {
        type: String,
        default: 'bg-none',
    },
    isFavorite: {
        type: Boolean,
        required: true,
    },
});

const svgClass = computed(() => {
    return props.isFavorite
        ? 'fill-orange-600 hover:fill-red-400 stroke-orange-600 hover:stroke-red-400 focus:stroke-orange-600 focus:fill-orange-600'
        : 'fill-none stroke-slate-800 dark:stroke-slate-300 hover:stroke-orange-600 dark:hover:stroke-orange-500 focus:stroke-slate-800 dark:focus:stroke-slate-300';
});
</script>
